// Root
const ROOT = '/'

// Shifts
// TODO Should be changed to '/active_shifts'
const ACTIVE_SHIFTS = '/active_shift'
const SHIFTS = '/shifts'
const MY_SHIFTS = '/my_shifts'
const RECOMMENDED_SHIFTS = '/recommended'
const FEATURED_SHIFTS = '/featured_shifts/:campaignId'
const SHIFTS_BY_BUSINESS = '/shifts_by_business/:businessId'
const PENDING_REVIEW_SHIFTS = '/pending_reviews'
const SHIFTS_BY_ID = '/shifts_by_id'

// Users
const USERS = '/users'
const USERS_ADD = '/users/add'
const USERS_EDIT = '/users/:id'

// Acknowledged Documents
const ACKNOWLEDGED_DOCUMENTS = '/acknowledged_documents'

// User
const MY_PROFILE = '/my_profile'
const NOTIFICATIONS = '/notifications'
const SETTINGS = '/settings'

// Authentication
const AUTHENTICATION = '/authentication'
const GOOGLE_AUTHENTICATION = '/google_authentication'
const LOGIN = '/login'
const FORGOT_PASSWORD = '/forgot_password'
const PASSWORD_RECOVERY = '/password_recovery'
const MAGIC_LINK = '/magic_link'
const MAGIC_LOGIN = '/magic_login'
const SIGN_UP = '/signup'
const CHANGE_PASSWORD = '/change_password'

// Employee Handbook
const EMPLOYEE_HANDBOOK = '/employee_handbook'

// Business
const FAVORITE_BUSINESSES = '/favorite_businesses'

// Onboarding Workflow Incomplete Steps
const INCOMPLETE_WORKFLOWS = '/incomplete_workflows/:id'
// Groups
const GROUPS = '/groups'
const GROUPS_VIEW = '/groups/:id'
const GROUPS_CREATE = '/groups/create'

// Acknowledge Documents
const ACKNOWLEDGE_DOCUMENTS = '/acknowledge_documents'

const ROUTES = {
  ROOT,
  AUTHENTICATION,
  MY_PROFILE,
  SETTINGS,
  NOTIFICATIONS,
  ACTIVE_SHIFTS,
  GOOGLE_AUTHENTICATION,
  SHIFTS,
  MY_SHIFTS,
  RECOMMENDED_SHIFTS,
  FEATURED_SHIFTS,
  PENDING_REVIEW_SHIFTS,
  USERS,
  USERS_ADD,
  USERS_EDIT,
  ACKNOWLEDGED_DOCUMENTS,
  FAVORITE_BUSINESSES,
  INCOMPLETE_WORKFLOWS,
  SHIFTS_BY_BUSINESS,
  GROUPS,
  GROUPS_VIEW,
  GROUPS_CREATE,
  ACKNOWLEDGE_DOCUMENTS,
  SIGN_UP,
  LOGIN,
  FORGOT_PASSWORD,
  PASSWORD_RECOVERY,
  MAGIC_LINK,
  MAGIC_LOGIN,
  CHANGE_PASSWORD,
  SHIFTS_BY_ID,
  EMPLOYEE_HANDBOOK,
} as const

export default ROUTES
